import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { F, Flex, Button } from 'nallian-shared-ui/lib/components';
import PrincipalAppFeature from './PrincipalAppFeature';

const FieldFlex = styled(Flex)`
  && .field {
    width: 100%;
  }
`;

const PrincipalAppFeatures = ({ formName, features, fields, editMode, readOnly, app }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (fields.length <= 0) fields.push({ isNew: true });
  }, [fields]);

  const handleAddFieldClick = useCallback(() => fields.push({ isNew: true }), [fields]);
  const handleRemoveFieldClick = useCallback(
    (_, { i }) => {
      if (fields.length <= 1) {
        fields.removeAll();
        fields.push({ isNew: true });
      } else {
        fields.remove(i);
      }
    },
    [fields]
  );

  return (
    <F.Field error={false}>
      <Flex fluid direction="column">
        <FieldFlex fluid direction="column" alignItems="flex-start">
          {fields.map((f, index) => (
            <PrincipalAppFeature
              readOnly={readOnly}
              editMode={editMode}
              fields={fields}
              index={index}
              field={f}
              app={app}
              features={features}
              key={`principalAppFeature_${index.toString()}`}
              handleRemoveFieldClick={handleRemoveFieldClick}
              formName={formName}
            />
          ))}
        </FieldFlex>
        {!readOnly && fields.length < features.length && (
          <Flex fluid justifyContent="flex-start" margin="1rem 0 1rem 0">
            <Button
              linkbutton
              icon="add"
              type="button"
              tabindex="-1"
              content={t('addFeature')}
              onClick={handleAddFieldClick}
            />
          </Flex>
        )}
      </Flex>
    </F.Field>
  );
};

PrincipalAppFeatures.propTypes = {
  readOnly: PropTypes.bool.isRequired,
  editMode: PropTypes.bool.isRequired,
  fields: PropTypes.array.isRequired,
  app: PropTypes.object.isRequired,
  features: PropTypes.array,
  formName: PropTypes.string,
};

PrincipalAppFeatures.defaultProps = { features: [], formName: undefined };

export default PrincipalAppFeatures;
